import themeGateway from "@vendor-app/gateways/ValidateThemeFile";
import { GettingStartedStoreAccess } from "../../store";

import { useToast } from "@vendor-app/app/_sharedComponents/Toast/ToastProvider";

export default function useValidateThemeProductFile() {
  const { setIsProductFileValid } = GettingStartedStoreAccess.useActions();

  const { addToast } = useToast();

  return async (themeId: string, fileName: string): Promise<void> => {
    try {
      const response = await themeGateway.validate(themeId, fileName);

      setIsProductFileValid(response);
    } catch {
      setIsProductFileValid(false);
      addToast("Failed to validate product.json theme file", true);
    }
  };
}
